<div class="badge__border">
  <div
    class="badge__wrapper"
    [class.border-red]="isPrivateHighlight === true"
    [class.border-green]="isPrivateHighlight === false"
    >
    <div class="badge__text" [style.backgroundColor]="color">
      @if (link && !embeddedService) {
        <a title="{{title || text}}" href="{{link}}" target="_blank">{{text}}</a>
      }
      @if (!link || embeddedService) {
        <span title="{{title || text}}">{{text}}</span>
      }
    </div>
    <div class="badge__icon">
      <i class="fa fa-star" [style.color]="color"></i>
    </div>
  </div>
</div>
